import React from 'react';
import { Button } from '../components/ui/button';
import { useToast } from '../hooks/use-toast';

const Contact = () => {
  const { toast } = useToast();
  const [formData, setFormData] = React.useState({
    name: '',
    email: '',
    message: '',
    sendCopy: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // In a real app, this would send to backend
    console.log('Form submitted:', formData);
    
    toast({
      title: "Message Sent!",
      description: "Thank you for reaching out. I'll get back to you within 24 hours.",
    });
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      message: '',
      sendCopy: false
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gray-50 py-16 md:py-20">
        <div className="container mx-auto px-6 max-w-3xl text-center">
          <h1 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: '#D4AF37' }}>
            Let's Talk About Your Online Presence
          </h1>
          <p className="text-gray-600 mb-8 leading-relaxed">
            Whether you want to book a free 20-minute audit or have questions about how I can help your practice convert more referrals, I'm here to help.
          </p>
          <a href="https://calendly.com/ainsleygreenslade/onlinepresenceaudit" target="_blank" rel="noopener noreferrer">
            <Button className="bg-[#F0C419] hover:bg-[#D4AF37] text-black font-medium px-8 py-3 rounded transition-colors duration-200 text-lg mb-4">
              Book Your Free 20-Minute Audit
            </Button>
          </a>
          <p className="text-gray-500 text-sm">
            Or send me a message using the form below
          </p>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="bg-white py-16 md:py-20">
        <div className="container mx-auto px-6 max-w-2xl">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center" style={{ color: '#D4AF37' }}>
            Send Me a Message
          </h2>
          <p className="text-gray-600 mb-8 text-center">
            Have a question? Need more information? Fill out the form below and I'll get back to you within 24 hours.
          </p>
          
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="name" className="block text-gray-700 mb-2 font-medium">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#F0C419] focus:border-transparent transition-all duration-200"
                placeholder="Dr. Jane Smith"
              />
            </div>
            
            <div>
              <label htmlFor="email" className="block text-gray-700 mb-2 font-medium">
                Email address <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#F0C419] focus:border-transparent transition-all duration-200"
                placeholder="your@email.com"
              />
            </div>
            
            <div>
              <label htmlFor="message" className="block text-gray-700 mb-2 font-medium">
                Message <span className="text-red-500">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="6"
                className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#F0C419] focus:border-transparent resize-none transition-all duration-200"
                placeholder="Tell me about your practice and what you're looking for help with..."
              ></textarea>
            </div>
            
            <div className="flex items-center">
              <input
                type="checkbox"
                id="sendCopy"
                name="sendCopy"
                checked={formData.sendCopy}
                onChange={handleChange}
                className="w-4 h-4 text-[#F0C419] border-gray-300 rounded focus:ring-[#F0C419] cursor-pointer"
              />
              <label htmlFor="sendCopy" className="ml-2 text-gray-700 cursor-pointer">
                Send me a copy of this message
              </label>
            </div>
            
            <Button 
              type="submit"
              className="w-full bg-[#F0C419] hover:bg-[#D4AF37] text-black font-medium px-8 py-3 rounded transition-colors duration-200 text-lg"
            >
              Send Message
            </Button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Contact;